<!--
Directions screen
@author bmk11u / crm4f
-->
<template>
  <div id="contain" class="container">
    <Nav name="Directions" v-bind:home="true" v-if="authenticated" />
    <Nav name="Directions" v-if="!authenticated" />
    <GMapMap :center='{lat:55.872446, lng:-4.289041}' :zoom='15'
      class='mapCanvas' ref='mapRef'
      :options='{
          styles: getStyles(),
          fullscreenControl: false,
          mapTypeControl: true,
          mapTypeControlOptions: {
            position: google && google.maps.ControlPosition.TOP_LEFT,
            style: google && google.maps.MapTypeControlStyle.DROPDOWN_MENU
          },
          streetViewControl: true,
          zoomControl: true
        }'>
    </GMapMap>
    <MapToolbar ref="mapToolbar"
      @showAccessibleRoutesChanged="(val) => onShowAccessibleRoutesChanged(val)"
      :useAccessibleRoutesEnabled="useAccessibleRoutesEnabled"
      @useAccessibleRoutesChanged="(val) => onUseAccessibleRoutesChanged(val)" />
    <!-- RESCOPE FINDASPACE -->
    <ul class="findaspace-nav-tabs nav nav-tabs eventNavUl">
      <li class="eventNav" style="font-weight:700 !important;" :class="dateActiveClass(0)">
        Directions
      </li>
      <li v-if="destination && destination.accessUrl" class="eventNav" :class="dateActiveClass(1)">
        <a class="" :href="destination.accessUrl" target="_blank" style="font-weight:700 !important;">Accessibility Guide</a>
      </li>
    </ul>
    <div class="p-2">
      <ul style="font-family: PTSans;" class="list-group pb-2">
        <li v-if="hasDirections" class="list-group-item list-group-item-secondary"><img alt="origin" height="32px" src="@/assets/A.svg"> {{ startAddress }}</li>
        <li v-if="hasDirections" class="list-group-item">{{ distanceAndDuration }}</li>
        <li v-for="step in steps" :key="step" v-html="step" class="list-group-item" />
        <li v-if="hasDirections" class="list-group-item list-group-item-secondary"><img alt="destination" height="32px" src="@/assets/B.svg"> {{ endAddress }}</li>
      </ul>
    </div>
    <div id="pusher"></div>
    <Footer active="notifications" v-if="authenticated"/>
  </div>
</template>

<script setup>
import axios from 'axios'
import MapToolbar from '@/components/MapToolbar.vue'
import { useMapCommon } from '@/composables/MapCommon.js'
import { useLocationsCommon } from '@/composables/LocationsCommon.js'
// import FeedbackForm from '@/components/FeedbackForm.vue'
import Footer from '@/components/FooterMenu.vue'
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const mapRef = ref(null)
const google = ref(null) /* to hold gmap api from promise */
const map = ref(null)
const mapToolbar = ref(null)

const fromId = ref(null)
const toId = ref(null)
const geoLatitude = ref(null)
const geoLongitude = ref(null)
const startAddress = ref(null)
const steps = ref([])
const endAddress = ref(null)
const distanceAndDuration = ref(null)
const useAccessibleRoutesEnabled = ref(false)
const origin = ref(null)
const destination = ref(null)
const waypoints = ref([])
const directionsRenderer = ref(null)
const hasDirections = ref(true)
const feedbackInfo = ref({})
const seltab = ref(0)

const route = useRoute()

const { clearFeatures, initFeatures, addMarker, initOverlays, getStyles } = useMapCommon()
const { authenticated } = useLocationsCommon()

onMounted(() => {
  toId.value = route.query.toId
  fromId.value = route.query.fromId
  geoLatitude.value = route.query.geoLatitude
  geoLongitude.value = route.query.geoLongitude

  // we need to get gmapApi...
  mapRef.value.$gmapApiPromiseLazy().then((gmapApi) => {
    console.log('gmapApi promise fulfilled')
    google.value = gmapApi
  }).then(() => {
  // Wait for Google Maps to load
    mapRef.value.$mapPromise.then((mapResponse) => {
      map.value = mapResponse
      // Get destination data
      axios.get('/map/locations/' + toId.value, { withCredentials: false })
        .then(response => {
          // Initialise overlays.
          destination.value = response.data
          initOverlays(map.value, google.value, mapToolbar.value)
          directionsRenderer.value = new google.value.maps.DirectionsRenderer({
            suppressMarkers: true,
            suppressInfoWindows: true,
            draggable: false
      })
          feedbackInfo.value.toId = toId.value
          if (fromId.value != null) {
            feedbackInfo.value.from = fromId.value
            // Get origin data
            axios.get('/map/locations/' + fromId.value, { withCredentials: false })
              .then(response => {
                origin.value = response.data
                if (origin.value.onAccessibleRoute && destination.value.onAccessibleRoute &&
                  origin.value.entrance.name !== destination.value.entrance.name) {
                  if (origin.value.locationId.substring(0, 3) !== destination.value.locationId.substring(0, 3)) {
                    useAccessibleRoutesEnabled.value = true
                  }

                  // Get waypoint data
                  axios.get('/map/locations/' + fromId.value + '/waypoints/' + toId.value, { withCredentials: false })
                    .then(response => {
                      let w = 0
                      waypoints.value = []
                      response.data.forEach((waypoint) => {
                        // console.log(waypoint)
                        if (w > 0 && w < response.data.length - 1) {
                          waypoints.value.push({ location: new google.value.maps.LatLng(waypoint.lat, waypoint.lng), stopover: true })
                        }
                        w += 1
                      })
                      displayDirections(map.value, origin.value, destination.value, false)
                    })
                } else {
                  displayDirections(map.value, origin.value, destination.value, false)
                }
              })
          } else {
            // Display directions from geo location to destination
            feedbackInfo.value.from = geoLongitude.value + ',' + geoLatitude.value
            displayDirections(map.value, null, destination.value, false)
          }
        })
      navigator.geolocation.getCurrentPosition(
        function (position) {
          let text = 'Your current location'
          let marker = addMarker(map.value, google.value, text, position.coords.latitude, position.coords.longitude, null, null, false, require('../../assets/location.png'))
          window.setTimeout(moveMarker, 5000, map.value, marker)
        }
      )
    })
  })
})

function dateActiveClass (tabNumber) {
  return { dateActive: seltab.value == tabNumber, dateInactive: seltab.value != tabNumber }
}

// eslint-disable-next-line no-unused-vars
function selectTab (t) {
  seltab.value = t + 0
  console.log(seltab.value)
}
// Recursively moves the current location marker every 5 seconds to show user movement
function moveMarker (map, marker) {
  navigator.geolocation.getCurrentPosition(
    function (position) {
      if (marker.getMap() != null) {
        marker.setPosition(new google.value.maps.LatLng(position.coords.latitude, position.coords.longitude))
        setTimeout(moveMarker, 5000, map, marker)
      } else {
        marker = null
      }
    }
  )
}

// Rerender directions when use accessible routes is selected
function onUseAccessibleRoutesChanged (val) {
  directionsRenderer.value.setMap(null)
  steps.value = []
  displayDirections(map.value, origin.value, destination.value, val)
}

// Rerender the all accessible route when show accessible routes is selected
function onShowAccessibleRoutesChanged (val) {
  let request = '/map/features?showBuildings=false&showAccessibleRoutes=' + val + '&showCycleRoutes=false&showAccessibleParking=false&showAccessibleToilets=false&showBikeRacks=false&showToilets=false&showFoodOutlets=false&showAttractions=false&showAtms=false&showShowers=false&showPrayerAndReflection=false&showBabyChanging=false&showDefibrillators=false&showPeriodProducts=false&showRetailOutlets=false&showWaterFountains=false&preview=false'
  clearFeatures(map.value)
  import('@/components/FeatureLabel.js')
    .then(FeatureLabel => {
      map.value.data.loadGeoJson(process.env.VUE_APP_WS_URL + request,
        {}, (features) => {
          initFeatures(map, FeatureLabel, features)
        })
    })
} 

// Display directions depending on origin type
function displayDirections (map, origin, destination, useAccessibleRoutes) {
  if (origin == null) {
    // Origin is current location, destination is building or room
    addMarker(map, google.value, 'Your current location', geoLatitude.value, geoLongitude.value, null, false, false, require('../../assets/origin.png'))
    addDestinationMarkers(map, destination)
    renderDirections(map, 'your current location', geoLatitude.value, geoLongitude.value, destination, useAccessibleRoutes)
  } else {
    if (origin.entrance.name === destination.entrance.name || origin.locationId.substring(0, 3) === destination.locationId.substring(0, 3)) {
      if (origin.locationId.length == 3 || destination.locationId.length == 3) {
        if (origin.locationId.length == 3) {
          addMarker(map, google.value, origin.locationName, origin.entrance.latLng.lat, origin.entrance.latLng.lng, null, false, false, require('../../assets/origin.png'))
          addMarker(map, google.value, destination.locationName, destination.latLng.lat, destination.latLng.lng, null, true, false, require('../../assets/destination.png'))
          steps.value.push('There\'s no route data available but the start and destination are shown on the map.')
          hasDirections.value = false
        }
        if (destination.locationId.length == 3) {
          addMarker(map, google.value, origin.locationName, origin.latLng.lat, origin.latLng.lng, null, false, false, require('../../assets/origin.png'))
          addMarker(map, google.value, destination.locationName, destination.entrance.latLng.lat, destination.entrance.latLng.lng, null, true, false, require('../../assets/destination.png'))
          steps.value.push('There\'s no route data available but the start and destination are shown on the map.')
          hasDirections.value = false
        }
      } else {
        // Origin and destination are rooms with the same entrance so show room locations but not directions
        addMarker(map, google.value, origin.locationName, origin.latLng.lat, origin.latLng.lng, null, false, false, require('../../assets/origin.png'))
        addMarker(map, google.value, destination.locationName, destination.latLng.lat, destination.latLng.lng, null, true, false, require('../../assets/destination.png'))
        steps.value.push('There\'s no route data available but the start and destination are shown on the map.')
        hasDirections.value = false
      }
    } else {
      // Origin is a building or room with a different entrance
      addMarker(map, google.value, origin.locationName + ' Exit', origin.entrance.latLng.lat, origin.entrance.latLng.lng, null, false, false, require('../../assets/origin.png'))
      addDestinationMarkers(map, destination)
      if (useAccessibleRoutes) {
        renderDirections(map, origin.locationName + ' Exit', origin.node.latLng.lat, origin.node.latLng.lng, destination, useAccessibleRoutes)
      } else {
        renderDirections(map, origin.locationName + ' Exit', origin.entrance.latLng.lat, origin.entrance.latLng.lng, destination, useAccessibleRoutes)
      }
    }
  }
}

// Adds an entrance marker for a building or room. Also adds a room marker for rooms with specified coordinates.
function addDestinationMarkers (map, destination) {
  addMarker(map, google.value, destination.locationName + ' Entrance', destination.entrance.latLng.lat,
    destination.entrance.latLng.lng, destination.directions, true, false, require('../../assets/destination.png'))
  if (destination.latLng != null) {
    // Destination is a room with its own coordinates so add another marker at its location
    addMarker(map, google.value, destination.locationName, destination.latLng.lat,
      destination.latLng.lng, null, false, false, require('../../assets/room.png'))
  }
}
// Calls the Google directions service to display directions on screen
function renderDirections (map, start, fromLat, fromLng, destination, useAccessibleRoutes) {
  let directionsService = new google.value.maps.DirectionsService()
  directionsRenderer.value.setMap(map)

  let waypnts = []
  if (useAccessibleRoutes) {
    waypnts = waypoints.value
  }

  directionsService.route({
    origin: { lat: Number(fromLat), lng: Number(fromLng) },
    destination: { 
      lat: useAccessibleRoutes ? Number(destination.node.latLng.lat) : Number(destination.entrance.latLng.lat), 
      lng: useAccessibleRoutes ? Number(destination.node.latLng.lng) : Number(destination.entrance.latLng.lng)
    },
    travelMode: google.value.maps.DirectionsTravelMode.WALKING,
    waypoints: waypnts
  }, function (response, status) {
    if (status === 'OK') {
      directionsRenderer.value.setDirections(response)
      writeDirections(response, start, destination, useAccessibleRoutes)
    } else {
      alert('Directions request failed due to ' + status)
    }
  })
}

// Custom directions text renderer.
function writeDirections (response, start, destination, useAccessibleRoutes) {
  let distance = 0
  let duration = 0
  let currentSteps = []
  steps.value = []
  // Routes loop
  response.routes.forEach((route) => {
    let l = 0
    // Legs loop
    route.legs.forEach((leg) => {
      if (l === 0) {
        writeStartAddress(leg, start, useAccessibleRoutes)
      }
      // Steps loop
      leg.steps.forEach((step) => {
        if (currentSteps.length > 0) {
          var last = currentSteps[currentSteps.length - 1]
          // Group consecutive steps with the same instructions together.
          if (last.instructions === step.instructions) {
            step.distance.value += last.distance.value
            currentSteps.splice(-1)
          }
        }
        currentSteps.push(step)
        distance += step.distance.value
        duration += step.duration.value
      })
      if (l === route.legs.length - 1) {
        writeSteps(currentSteps, useAccessibleRoutes)
        writeEndAddress(leg, destination, useAccessibleRoutes)
      }
      l += 1
    })
  })
  distanceAndDuration.value = formatDistanceAndDuration(distance, duration, useAccessibleRoutes)
}

// Writes the start address for custom directions text renderer.
function writeStartAddress (leg, start, useAccessibleRoutes) {
  // Add start address.
  if (useAccessibleRoutes) {
    leg.start_address = start
  } else {
    leg.start_address = 'Depart from ' + start
  }
  startAddress.value = leg.start_address
}

// Writes the steps for custom directions text renderer.
function writeSteps (stepsArg, useAccessibleRoutes) {
  stepsArg.forEach((step) => {
    var text = step.instructions
    if (text != null) {
      text = text.replace(/Walk/g, 'Head')
      text = text.replace(/walk/g, 'head')
      if (useAccessibleRoutes) {
        text = text.replace(/Take the stairs/g, '')
        text = text.replace(/take the stairs/g, '')
      }
    }
    steps.value.push(text + ' (' + formatDistance(step.distance.value) + ')')
  })
}

// Writes the end address for custom directions text renderer.
function writeEndAddress (leg, destination, useAccessibleRoutes) {
  leg.end_address = destination.locationName + ' Entrance'
  if (useAccessibleRoutes && destination.accessUrl != null) {
    leg.end_address = leg.end_address + '. See Accessibility Guide link above for building access info.'
  } else {
    leg.end_address = 'Arrive at ' + leg.end_address
    if (destination.directions != null) {
      leg.end_address = leg.end_address + '. ' + destination.directions
    }
  }
  endAddress.value = leg.end_address
}

// Formats distance and duration for custom directions text renderer.
function formatDistanceAndDuration (distance, duration, useAccessibleRoutes) {
  let distanceAndDuration = formatDistance(distance)
  if (!useAccessibleRoutes) {
    distanceAndDuration += '. '
    distanceAndDuration += formatDuration(duration)
  }
  return distanceAndDuration
}

// Formats distance for custom directions text renderer.
function formatDistance (distance) {
  if (distance < 100) {
    distance += ' m'
  } else {
    distance = distance / 1000
    distance = distance.toFixed(1)
    distance += ' km'
  }
  return distance
}

// Formats duration for custom directions text renderer.
function formatDuration (duration) {
  if (duration < 60) {
    duration = 1
  } else {
    duration = duration / 60
    duration = Math.round(duration)
  }
  if (duration === 1) {
    duration = 'About 1 min'
  } else {
    duration = 'About ' + duration + ' mins'
  }
  return duration
}
</script>
<style scoped>
.eventNav {
  display: block;
  width:50%;
  text-align:center;
  line-height:50px;
  height:50px;
}

.findaspace-nav-tabs {
  background-color:#f0f1f1 !important;
}

.eventNavUl {
  padding-left:0% !important;
  padding-right:0% !important;
  border-bottom:0px !important;
  overflow: hidden;
}

.dateActive {
  color: #951272;
}
.dateInactive a {
  color: #003865;
}
</style>
